import React, { Component } from "react";

class InfoDataPanel extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);

    this.createDataList = this.createData.bind(this);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

  createData() {
    let output = [];
    this.state.data.map((itm, idx) => {
      output.push(
        <div key={idx}>
          <div className="home-remain">
            <div className="hold">
              <h2
                id="allMBsAreConsumedHeader"
                className="invislible"
                style={{ lineHeight: "normal;", display: "block;" }}
              >
                Έχετε καταναλώσει <br />
                όλα τα MB για Internet
              </h2>

              <h5 id="availableMBHeader" className="invislible">
                Τα διαθέσιμα MB σας για Internet είναι:
              </h5>
              {itm.showInfo.component}
            </div>
          </div>
          <div className="ammount-remain hidden" style={{ display: "none" }}>
            {/* if you want to be displayed on screen write this --> <div className="ammount-remain">*/}
            <div className="line"></div>
            <div className="hold">
              <h4 className="remainmb">
                +<span className="customClassBalanceRemaining"></span>
              </h4>
              <div className="remainmbduration">από 00:00 - 08:00</div>
            </div>
            <div className="line"></div>
          </div>
        </div>
      );
    });
    return <div>{output}</div>;
  }

  render() {
    if (this.state.loaded) {
      return this.createData();
    } else {
      return "";
    }
  }
}

export default InfoDataPanel;
